module.exports = __webpack_public_path__ + "static/img/200160.498789f5.png";